import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IGovIdProof } from '../models/govId.model';

export const archivedProofGovIdFeatureKey = 'archivedProofGovId';

export interface ArchivedProofGovIdState {
  loadArchivedProofGovIds: string;
  loadArchivedProofGovIdsSuccess: IGovIdProof[];
  loadArchivedProofGovIdsFailure: Error | any;
}

export const initialState: ArchivedProofGovIdState = {
  loadArchivedProofGovIds: undefined,
  loadArchivedProofGovIdsSuccess: undefined,
  loadArchivedProofGovIdsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.fromGovIdProofActions.loadPreviousProofGovIds, (state, action) => ({
    ...state,
    loadArchivedProofGovIds: action.request
  })),
  on(actions.fromGovIdProofActions.loadPreviousProofGovIdsSuccess, (state, action) => ({
    ...state,
    loadArchivedProofGovIdsSuccess: action.response
  })),
  on(actions.fromGovIdProofActions.loadPreviousProofGovIdsFailure, (state, action) => ({
    ...state,
    loadArchivedProofGovIdsFailure: action.error
  }))
);

export const getPreviousProofGovIds = (state: ArchivedProofGovIdState) => state.loadArchivedProofGovIdsSuccess;
